import React from "react";
import { ExternalLink } from "./Ui";
import { formatAmount } from "../utils";

// Summary of a proposed close-out (ai.closeOut): outcome, target opportunity,
// the evidence the AI relied on and any hold reasons (already closed, no target...)
export default function CloseOutPanel({ closeOut, target, flags = [], plan }) {
  const co = closeOut || {};
  const outcome = co.outcome === "won" ? "won" : co.outcome === "lost" ? "lost" : "unknown";
  const alreadyClosed = flags.includes("already_closed") || ((plan && plan.actions) || []).some((a) => a.type === "close_opportunity" && a.status === "skipped");
  const noTarget = flags.includes("no_opportunity_to_close") || (!target && !((plan && plan.actions) || []).some((a) => a.type === "close_opportunity"));

  return (
    <div className={`ob-closeout ob-closeout--${outcome}`}>
      <div className="ob-closeout__head">
        <span className="ob-closeout__badge">{outcome === "won" ? "Closed Won" : outcome === "lost" ? "Closed Lost" : "Close - outcome unclear"}</span>
        {target ? (
          <span className="ob-closeout__target">
            <ExternalLink href={target.url}>{target.name}</ExternalLink>
            <span className="ob-muted"> · {[target.recordTypeName, target.stageName, target.ownerName].filter(Boolean).join(" · ")}</span>
          </span>
        ) : (
          <span className="ob-closeout__target ob-muted">No matching opportunity found on the prospect's account</span>
        )}
      </div>

      {alreadyClosed && target && (
        <div className="ob-notice ob-notice--info" style={{ marginTop: 8 }}>
          <b>{target.name}</b> is already <b>{target.stageName}</b>
          {target.closeDate ? ` (close date ${target.closeDate})` : ""}. Nothing changes on the opportunity - approving only logs this email as a Task on it.
          {target.lossReason ? (
            <div className="ob-closeout__onfile">
              Loss reason already on file: <i>{target.lossReason}</i>
            </div>
          ) : null}
        </div>
      )}
      {noTarget && !alreadyClosed && (
        <div className="ob-notice ob-notice--warning" style={{ marginTop: 8 }}>
          The email reads as a close-out but the bot could not find an opportunity to close. Forward it again with the opportunity name in your notes, or close it by hand in Salesforce.
        </div>
      )}

      <dl className="ob-closeout__facts">
        {co.closeDate && (
          <>
            <dt>Close date</dt>
            <dd>{co.closeDate}</dd>
          </>
        )}
        {outcome === "won" && (
          <>
            <dt>Amount</dt>
            <dd>{co.wonAmount !== null && co.wonAmount !== undefined ? formatAmount(co.wonAmount) : <span className="ob-inline-error">not stated</span>}</dd>
            {co.numberOfEvents !== null && co.numberOfEvents !== undefined && (
              <>
                <dt># of Curate events</dt>
                <dd>{co.numberOfEvents}</dd>
              </>
            )}
          </>
        )}
        {outcome === "lost" && co.lossReason && (
          <>
            <dt>Loss reason</dt>
            <dd>{co.lossReason}</dd>
          </>
        )}
      </dl>
      {co.evidenceQuote && (
        <blockquote className="ob-closeout__quote">
          <span className="ob-eyebrow">Evidence from the thread</span>
          {co.evidenceQuote}
        </blockquote>
      )}
    </div>
  );
}
